import React from "react";
export default class Step5 extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            selected: []
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            const selected = this.props.selected.map(s => this.props.options.find(o => o.id == parseInt(s)));
            this.setState({
                selected
            });
        }
    }
    render() {
        const { options, handleChange } = this.props;
        //@ts-ignore: This is passed through
        //const nextStep = this.props.nextStep
        return (React.createElement("div", { className: "card card-body protein-card" },
            React.createElement("p", null, "Do you have any additional restrictions?"),
            React.createElement("div", { className: "row align-items-stretch" }, options.map((option, idx) => (React.createElement("div", { className: "col-md-6 col-lg-4 mb-3", key: idx },
                React.createElement("div", { className: "form-check custom-check h-100" },
                    React.createElement("input", { className: "form-check-input", type: "checkbox", name: "options", value: option.id, id: option.code, disabled: this.isDisabled(option), onChange: (e) => handleChange(e, "options") }),
                    React.createElement("label", { className: "form-check-label h-100", htmlFor: option.code },
                        React.createElement("span", { className: "custom-check-text" },
                            option.name,
                            React.createElement("br", null),
                            React.createElement("small", null,
                                option.description,
                                "*")))))))),
            React.createElement("p", { className: "text-muted hanging-asterisk" }, "Per day restrictions are averages and may vary based on your other dietary preferences. Some days may contain slightly more calories, some days slightly fewer.")));
    }
    isDisabled(option) {
        const { linked, id } = option;
        if (linked == null)
            return false;
        return this.state.selected
            .filter(s => (s === null || s === void 0 ? void 0 : s.linked) === linked && s.id !== id).length !== 0;
    }
}
